import { useEffect, useRef, useState } from "react";
import GlobalVar from "./GlobalVar";

function checkImage(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
}

const ProdutoCard = ({prod, dispachInfo}) =>{

    const urlImage = `https://apirevendedoratime.babita.com.br/images/${prod.cod_ref}.jpg`


const [bg, setBg] = useState('#FFF');

  useEffect(() => {
    //   console.log("TESTE IMAGE")
    const img = new Image();
    img.src = urlImage;

    img.onload = () => {
      setBg(`url('${urlImage}')`);
    };

    img.onerror = () => {
      setBg(`url('https://apifornecedores.babita.com.br/images/publicImages/ImagemNaoEncontrada.jpg')`);
    };
  }, [urlImage]);

  // useEffect(()=>{
  //   if(prod){
  //     console.log(prod.tamanhos_estampas)
  //     console.log(adaptarTamanhosEstampas(prod.tamanhos_estampas))
  //   }
  // },[prod])
  
    

    return <div className="prodCard">
                        <div className='fotoProd'
                        style={{background: `${bg} no-repeat center/contain`}}
                        onClick={async ()=>{
                            console.log(prod)
                            await dispachInfo({type: 'produtoPagina', value: prod})
                            await dispachInfo({type: 'telaAtual', value: 2})
                            }}>
                            <div className="colorCircles">
                            {adaptarTamanhosEstampas(prod.tamanhos_estampas).map((item) => {
                                return item.label == 'VARIACAO'? <></> : 
                                <div
                                    className={`colorCircleUnique ${item.raw}`}
                                    loading="lazy"
                                    style={
                                    !item.isCorDaFoto && item.isColorHex
                                        ? { backgroundColor: item.corOuImagem }
                                        : { background: '#000000'/*`${bg} no-repeat top/cover`*/ }
                                    }
                                />
                                
                                
                                  })}
                            </div>
                        </div>
                        <div className="infoCard">
                            {/* <div className="prodTitulo" >{prod.descbasica.concat(" - ", prod.rev_nom)}{" . PAG.:"+ prod.pagina}</div> */}
                            <div className="prodTitulo" >{prod.prod_titulo.concat(" - ", prod.rev_nom)}{" . PAG.:"+ prod.pagina}</div>
                            <div className="prodRef">Ref.: {prod.cod_ref}</div>
                            {/* <div className="prodForn">{prod.for_nomfant}</div> */}
                            <div className="prodPreco">R$ {GlobalVar.converteFloat(parseFloat(prod.produto_preco))}</div>   
                            
                        </div>
                    </div>
}



export const ShowProdutosDisponiveis = ({produtos, showStyle, dispachInfo, stateInfo})=>{

    const [visibleItems, setVisibleItems] = useState(8);
    const [loading, setLoading] = useState(false);

    const handleScroll = () => {
        const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight;
        if (bottom && !loading && visibleItems < produtos.length) {
          setLoading(true);
            setVisibleItems(prev => prev + 8); // Carrega mais 10 itens
            setLoading(false);
        }
      };
    
      useEffect(() => {
        // if(produtos){
        // }
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, [produtos]); // Adiciona e remove o listener de scroll no montar e desmontar do componente

      

      useEffect(() => {
        if (showStyle) {
          // Importa dinamicamente quando necessário
          import('../../assets/css/estiloPaginas/prodCardTirarPedido.css');
        }
      }, [showStyle]);

    return <>
    <div className='prodList'>
        {produtos.filter((val) => val.descbasica == stateInfo.categoriaSelecionada || !stateInfo.categoriaSelecionada).sort((a, b) => a.pagina - b.pagina).slice(0, visibleItems).map((prod)=> <ProdutoCard prod={prod} key={prod.cod_ref} dispachInfo={dispachInfo}/> )}
    </div>
        {loading && <div>Carregando...</div>}
    </>
}





function adaptarTamanhosEstampas(tamanhosEstampas) {
    if (!tamanhosEstampas) return []
  
    return tamanhosEstampas
      .split(' | ')
      .map((item) => {
        const [info, valor] = item.split(':')
        const [label, corOuImagem] = info.split(' || ')
  
        return {
          raw: item,
          label,
          corOuImagem,
          valor,
          isCorDaFoto: label === 'Cor da Foto',
          isColorHex: /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(corOuImagem),
        }
      })
      .sort((a, b) => {
        // Cor da Foto sempre primeiro
        if (a.isCorDaFoto && !b.isCorDaFoto) return -1
        if (!a.isCorDaFoto && b.isCorDaFoto) return 1
        return 0
      })
  }